const keyBy = require('lodash/keyBy');
const minBy = require('lodash/minBy');
const pulseLocations = require('../config/pulseLocations');

const pulseLocationsByKey = keyBy(pulseLocations, 'key');

module.exports = function getDefaultPulses(systolicBP) {
  return pulseLocations.map((location) => ({
    location: location.key,
    strength: getDefaultPulseStrength(location.key, systolicBP),
  }));
};

function getDefaultPulseStrength(locationKey, systolicBP) {
  const location = pulseLocationsByKey[locationKey];
  if (!location) {
    throw new Error('Could not find locationKey ', locationKey);
  }
  const closestStrengthTuple = minBy(location.systolicBPStrengthTuples, tuple => Math.abs(systolicBP - tuple[0]));
  const closestStrength = closestStrengthTuple[1];
  return closestStrength;
}
